import { DateTime } from "luxon";
import {
  FleetManagementRow,
  VehicleBookingEventDto
} from "../../FleetManagement/types/FleetManagement-row.types";

/**
 * Returns true if the user has an overlapping checked-in or checked-out booking on any vehicle
 * in the fleet list. Used to show "please contact admin" before the fleet table (Availability step).
 */
export function hasUserOverlappingCheckedInBookingInFleet(
  fleetData: FleetManagementRow[] | undefined,
  newStartIso: string,
  newEndIso: string,
  userIdToCheck: string
): boolean {
  if (!fleetData?.length || !newStartIso || !newEndIso) return false;
  return fleetData.some(row =>
    hasOverlappingCheckedInFleetBooking(row.occupiedBooking, newStartIso, newEndIso, userIdToCheck)
  );
}

/**
 * Returns true if there is an overlapping occupied booking that is checked in or checked out
 * and belongs to the given user (same user we're booking for).
 */
export function hasOverlappingCheckedInFleetBooking(
  occupiedBooking: VehicleBookingEventDto[] | undefined,
  newStartIso: string,
  newEndIso: string,
  userIdToCheck: string
): boolean {
  if (!occupiedBooking?.length || !newStartIso || !newEndIso) return false;

  const newStart = DateTime.fromISO(newStartIso);
  const newEnd = DateTime.fromISO(newEndIso);
  if (!newStart.isValid || !newEnd.isValid) return false;

  return occupiedBooking.some(booking => {
    const isCheckedInOrOut = booking.isCheckedIn === true || booking.isCheckedOut === true;
    if (!isCheckedInOrOut) return false;

    const bookingUser = booking.userBookedFor?.trim();
    if (bookingUser === "" || bookingUser !== userIdToCheck) return false;

    const bookingStart = DateTime.fromISO(booking.startTime);
    const bookingEnd = DateTime.fromISO(booking.endTime);
    if (!bookingStart.isValid || !bookingEnd.isValid) return false;

    return (
      (bookingStart <= newStart && bookingEnd >= newStart) ||
      (bookingStart <= newEnd && bookingEnd >= newEnd) ||
      (bookingStart >= newStart && bookingEnd <= newEnd)
    );
  });
}
